export const utcTimestampToLocalDate = (utcTimestamp: string): string => {
	const date = new Date(utcTimestamp);
	const offset = date.getTimezoneOffset();
	const localDate = new Date(date.setMinutes(date.getMinutes() - offset));
	return localDate.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});
};
